import { useState, memo, useEffect } from 'react';
import usePlayVideo from '@@/hooks/usePlayVideo';
import CanvasGold from '../CanvasGold';
import CanvasFeather from '../CanvasFeather';

import styles from './style.module.scss';

const Top = ({ active }) => {
  const playVideo = usePlayVideo();
  const [showScrollTip, setShowScrollTip] = useState(false); // 是否显示滚动提示

  const onPlayVideo = () => {
    playVideo('https://static.papegames.com/nikkiweb/papegame/evolcn/material/iwnizwg_/PXSJ_0731.mp4');
  };

  useEffect(() => {
    if (showScrollTip) return;
    const timer = setTimeout(() => {
      setShowScrollTip(true);
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [showScrollTip]);

  return (
    <div className={styles.container}>
      <CanvasGold />
      <CanvasFeather />
      <div className={styles.playBtn} onClick={onPlayVideo}>
        <div className={styles.outerCircle} />
        <div className={styles.innerPlate} />
        <div className={styles.playIcon} />
      </div>
      <div className={`${styles.bottomImg} ${active ? styles.active : ''}`} />
      {showScrollTip && <div className={styles.scrollTip} />}
    </div>
  );
};

export default memo(Top);
